const ricker = require("./src/ricker");
const convolve = require("./src/convolve");
const findPeaks = require("./src/findPeaks");

module.exports = {
  ricker,
  convolve,
  findPeaks,
};
